import { Column, DateColumn, GridPreLoaded } from "@repo/ui";

import { useRepQueries } from "../../../api/repApi";
import { Rep } from "../../../models";

const columns = [
	new Column("Rep ID", "login"),
	new Column("First Name", "firstName"),
	new Column("Last Name", "lastName"),
	new DateColumn("Start Date", "startDate").dateOnly(),
	new Column("State", "state"),
] as Column<Rep>[];

export function RelatedRepsGrid() {
	const { useRelatedRepsQuery } = useRepQueries();
	const query = useRelatedRepsQuery();

	return (
		<GridPreLoaded
			id="relatedRepsGrid"
			columns={columns}
			keyProperty="startDate"
			values={query.data ?? []}
			loading={!query.loaded}
			getData={() => query.clearQuery()}
		/>
	);
}
